import Navbar from "./components/Navbar/Navbar";
import Intro from "./components/Intro/Intro";
//import Services from "./components/Services/Services";
import "./App.css";
//import Experience from "./components/Experience/Experience";
//import Works from "./components/Works/Works";
//import PhotoGallery from "./components/PhotoGallery/PhotoGallery";
import { TailSpin } from "react-loader-spinner";
import Portfolio from "./components/Portfolio/Portfolio";
//import Testimonial from "./components/Testimonials/Testimonial";

//import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import React, { useContext } from "react";
import { themeContext } from "./Context";
import DevelopedBy from "./components/DevelopedBy/DevelopedBy";
//FOR TESTING
// const PhotoGallery = React.lazy(() => {
//   return new Promise((resolve) => setTimeout(resolve, 10000)).then(() =>
//     import("./components/PhotoGallery/PhotoGallery")
//   );
// });
const Experience = React.lazy(() =>
  import("./components/Experience/Experience")
);
const Services = React.lazy(() => import("./components/Services/Services"));
const PhotoGallery = React.lazy(() =>
  import("./components/PhotoGallery/PhotoGallery")
);
//const Portfolio = React.lazy(() => import("./components/Portfolio/Portfolio"));
const Testimonial = React.lazy(() =>
  import("./components/Testimonials/Testimonial")
);
const Contact = React.lazy(() => import("./components/Contact/Contact"));
function App() {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <>
    <div
      className="App"
      style={{
        background: darkMode ? "black" : "",
        color: darkMode ? "white" : "",
      }}
    >
      <Navbar />
      <Intro />

      <React.Suspense
        fallback={
          <div
            style={{
              height: "60px",
              display: "flex",

              justifyContent: "center",
            }}
          >
            <TailSpin color="#FCA61F" height={80} width={80} />
          </div>
        }
      >
        <Services />
      </React.Suspense>
      <React.Suspense
        fallback={
          <div
            style={{
              height: "60px",
              display: "flex",

              justifyContent: "center",
            }}
          >
            <TailSpin color="#FCA61F" height={80} width={80} />
          </div>
        }
      >
        <Experience />
      </React.Suspense>

      <React.Suspense
        fallback={
          <div
            style={{
              height: "60px",
              display: "flex",

              justifyContent: "center",
            }}
          >
            <TailSpin color="#FCA61F" height={80} width={80} />
          </div>
        }
      >
        <PhotoGallery />
      </React.Suspense>

      <Portfolio />
      {/* portfolio is now video gallery */}
      <React.Suspense
        fallback={
          <div
            style={{
              height: "60px",
              display: "flex",

              justifyContent: "center",
            }}
          >
            <TailSpin color="#FCA61F" height={80} width={80} />
          </div>
        }
      >
        <Testimonial />
      </React.Suspense>
      <React.Suspense
        fallback={
          <div
            style={{
              height: "60px",
              display: "flex",

              justifyContent: "center",
            }}
          >
            <TailSpin color="#FCA61F" height={80} width={80} />
          </div>
        }
      >
        <Contact />
      </React.Suspense>
      <Footer />
    </div>
      <DevelopedBy />
      </>
  );
}

export default App;
